import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { styled } from '@mui/material/styles';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OkButton = styled(Button)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  background: "#ff9c08",
  textTransform: "uppercase",
  color: "#fff",
  paddingRight: "20px",
  fontSize: "16px",
  letterSpacing: "0.03rem",
  borderRadius: "4px",
  fontWeight: 500,
  height: "45px",
  cursor: "pointer",
  marginRight: "12px",
  textAlign: "center",

  '&:hover': {
    background: "#d98507",
  },
});

const CancelButton = styled(Button)({
  display: "flex",
  background: "#fff",
  justifyContent: "flex-end",
  alignItems: "center",
  border: "2px solid #ff9c08",
  textTransform: "uppercase",
  color: "#ff9c08",
  padding: "15px 15px",
  fontSize: "16px",
  letterSpacing: "0.03rem",
  borderRadius: "4px",
  fontWeight: 500,
  height: "45px",
  cursor: "pointer",
  marginRight: "12px",

  '&:hover': {
    color: "#fff",
    background: "#ff9c08",
  },
});

function ConfirmationDialogRaw(props) {
  const { onClose, open, cancelRequired = true, width=50, dialogConfirmationTitle = 'Confirmation', dialogConfirmationMessage = 'Are Your Sure ?', ...other } = props;

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };
  const widthStyle = {
    width:`${width}%`
  }

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { ...widthStyle, maxHeight: 435 } }}
      maxWidth="xxl"
      TransitionComponent={Transition}
      open={open}
      {...other}
    >
      <DialogTitle sx={{ backgroundColor: "#0086ff", color: "#fff" }}>{dialogConfirmationTitle}</DialogTitle>
      <DialogContent dividers>
        {dialogConfirmationMessage}
      </DialogContent>
      <DialogActions>
        {cancelRequired && <CancelButton autoFocus onClick={handleCancel}>Cancel</CancelButton>}
        <OkButton onClick={handleOk}>Ok</OkButton>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialogRaw.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ConfirmationDialogRaw